"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        var _this = _super.call(this) || this;
        _this.RRSSLinks = {
            facebook: 'https://www.facebook.com/rurallure/',
            twitter: 'https://twitter.com/rurallure',
            instagram: 'https://www.instagram.com/rurallure_eu/',
            youtube: 'https://www.youtube.com/channel/UCA8USZccHJXXOjIzh5g3oeA'
        };
        _this.currentYear = new Date().getFullYear();
        _this.partnership = null;
        _this.loadPartnershipData();
        _this.$root.$on('PARTNERSHIP_SELECTED', _this.loadPartnershipData);
        return _this;
    }
    Footer.prototype.loadPartnershipData = function () {
        var _this = this;
        var slug = this.$browserStorage.getCookie('slug');
        if (!slug) {
            return;
        }
        this.$getPartnershipDataService.request(slug).then(function (response) {
            _this.partnership = response;
        }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    Footer = __decorate([
        vue_property_decorator_1.Component({
            name: 'Footer'
        })
    ], Footer);
    return Footer;
}(vue_1.default));
exports.default = Footer;
